import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    Form,
    Alert,
    Spinner
} from 'reactstrap';

import {useSelector, useDispatch} from "react-redux";

import {Link} from "react-router-dom";
import withRouter from "../common/withRouter";
import * as Yup from "yup";
import {useFormik} from "formik";
import {
    deviceSurveyStart,
} from '../slices/survey'
import {recordActivity} from "../slices/register";

const Landing = (props) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)

    const {error} = useSelector(state => ({
        ...state
    }));


    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {},
        onSubmit: (values) => {
            setLoading(true)
            let deviceId = sessionStorage.getItem('device') || undefined
            dispatch(deviceSurveyStart(deviceId, values, (data) => {
                props.router.navigate('/eligibility-assessment')
                setLoading(false)
            }))
        }
    });

    useEffect(() => {
        let deviceId = sessionStorage.getItem('device') || undefined
        dispatch(recordActivity(deviceId, {
            action: "survey",
            page_id: "0-7"
        }))
    }, [dispatch, sessionStorage, recordActivity])

    document.title = "Online Eligibility Survey";
    return (
        <React.Fragment>
            <div>
                <Container>
                    <Row className="pt-5  justify-content-center">
                        <Col className="p-0" xl={10} md={10} sm={12}>
                            <div className="text-center mt-2">
                                <h3>Online Eligibility Survey</h3>
                            </div>
                            <Card className="mt-4">
                                <CardBody className="p-4">
                                    {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                    <div className="p-2 mt-4">
                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                            action="#">

                                            <Row className="justify-content-center">
                                                <Col className="pr-5 pl-5 justify-content-center" xl={10} md={10}
                                                     sm={12}>
                                                    <p style={{textAlign: "center"}}>Please answer the following questions to see if you are eligible for this study.
                                                    </p>
                                                </Col>
                                                <Col className="pr-5 pl-5" xl={5} md={6} sm={12}>
                                                    <div className="mt-4">
                                                        <Button aria-label={"begin assessment"}
                                                                disabled={error ? null : loading ? true : false}
                                                                className="btn button-primary w-100" type="submit">
                                                            Begin Survey
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
        ;
};

export default withRouter(Landing);
